import { Button, TextArea, Typography } from "@king-ict/eupisi-ui/components";
import { ReactComponent as EditIcon } from "@king-ict/eupisi-ui/components/Icon/Edit.svg";
import { hrDate, hrShortTime, nameof } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { CreateUpdateRequestComment, RequestComment } from "../../models";
import styles from "./Comment.module.scss";

export interface CommentProps {
  requestComment: RequestComment;
  newComment: CreateUpdateRequestComment;
  onEditClick: (commentId: number) => void;
  onCancelClick: () => void;
  onSaveClick: () => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isEditable?: boolean;
}

export const Comment = ({
  requestComment,
  newComment,
  isEditable,
  onEditClick,
  onSaveClick,
  onCancelClick,
  onChange,
}: CommentProps) => {
  const { t } = useTranslation();
  return requestComment.editing ? (
    <>
      <TextArea
        label={t("request.initialConversation.yourComment")}
        ariaLabel={t("request.initialConversation.yourComment")}
        value={newComment.comment}
        rows={4}
        onChange={(e) => onChange(e)}
        name={nameof<typeof newComment>("comment")}
      />
      <div className={styles.commentButtons}>
        <Button className={styles.cancelButton} outline onClick={onCancelClick}>
          {t("common.cancel")}
        </Button>
        <Button color="primary" onClick={onSaveClick}>
          {t("request.initialConversation.saveCommentButton")}
        </Button>
      </div>
    </>
  ) : (
    <div className={styles.commentContainer}>
      <Row>
        <Col md={10}>
          <Typography variant="baseBold" className={styles.commentHeader}>
            {requestComment.createdByName}
          </Typography>
        </Col>
        <Col md={2}>
          {isEditable && (
            <EditIcon
              className={styles.editIcon}
              onClick={() => onEditClick(requestComment.id)}
            />
          )}
        </Col>
      </Row>

      <Typography variant="small" color="light">
        {`${hrDate(requestComment.dateCreated)} ${hrShortTime(
          requestComment.dateCreated
        )}`}
        {requestComment.dateUpdated &&
          ` (${t("request.initialConversation.edited")} ${hrDate(
            requestComment.dateUpdated
          )} ${hrShortTime(requestComment.dateUpdated)})`}
      </Typography>
      <Typography variant="base" color="base">
        {requestComment.comment}
      </Typography>
    </div>
  );
};
